import tracker from '../tracker/publish'
import redirect from '../../utils/redirect'

define(['app', 'jquery', 'underscore'], function (app, $, _) {
  return app.Marionette.ItemView.extend({
    template: false,

    ui: {
      notifications: '.js-notification',
      submit: '[type="submit"]',
      text_inputs: 'input, textarea',
      all_inputs: 'select, input, textarea'
    },

    options: {
      onSuccessRedirect: true,
      enableSubmitButton: false,
      labels: {
        connection_error: 'Sorry something went wrong, the request was answered in unexpected way. Please try again.'
      }
    },

    events: {
      submit: 'submitForm',
      'change @ui.all_inputs': 'enableSubmitButton',
      'keyup @ui.text_inputs': 'enableSubmitButton',
      'focus @ui.all_inputs': 'resetErrors'
    },

    components: {
      notifications: {
        name: 'notifications',
        el: '@ui.notifications'
      }
    },

    notifications: false,
    onComponentNotificationsLoaded: function (instance) {
      this.notifications = instance
    },

    enableSubmitButton: function () {
      // We check if this function is set in the options
      if (this.options.enableSubmitButton) {
        var valid = true
        var requiredInputs = this.ui.all_inputs.filter('[required]')

        requiredInputs.each(function (index, el) {
          if (valid && !app.$(el).val()) valid = false
        })

        this.ui.submit.prop('disabled', !valid)
      }
    },

    resetErrors: function () {
      this.notifications.triggerMethod('notification:clean')
      this.$el.find('.error').removeClass('error')
    },

    getErrors: function (errors, parent) {
      var self = this
      var _errors = []
      var translations = app.translations
        ? app.translations.get('ajax-form')
        : false

      if (!errors) {
        _errors.push({
          type: 'error',
          msg: translations
            ? translations.connection_error
            : this.getOption('labels').connection_error
        })
      } else {
        // Looping to the errors
        _.each(errors, function (error) {
          // Is an object
          if (_.isObject(error) && !_.isArray(error)) {
            _errors = _.union(_errors, self.getErrors(error, parent, true))
          } else if (_.isArray(error)) {
            // is an Array
            _.each(error, function (value) {
              _errors.push({
                type: 'error',
                msg: value
              })
            })
          } else {
            // This should be a string
            _errors.push({
              type: 'error',
              msg: error
            })
          }
        })
      }

      return _errors
    },

    getSuccessMessages: function (messages, parent) {
      var self = this
      var _messages = []

      // Looping to the messages
      _.each(messages, function (message) {
        // Is an object
        if (_.isObject(message) && !_.isArray(message)) {
          _messages = _.union(
            _messages,
            self.getSuccessMessages(message, parent, true)
          )
        } else if (_.isArray(message)) {
          // is an Array
          _.each(message, function (value) {
            _messages.push({
              type: 'success',
              msg: value
            })
          })
        } else {
          // This should be a string
          _messages.push({
            type: 'success',
            msg: message
          })
        }
      })

      return _messages
    },

    onShowInputErrors: function (errors, parent) {
      var self = this

      if (!errors) return false

      // Looping to the errors
      _.each(errors, function (error, index) {
        var name = parent + '[' + index + ']'
        // Is an object
        if (_.isObject(error) && !_.isArray(error)) {
          self.onShowInputErrors(error, name, true)
        } else {
          var input = self.$el.find('[name*="' + name + '"]')
          if (input.length > 0) input.addClass('error')
        }
      })
    },

    showErrors: function (errors, parent) {
      this.triggerMethod('show:input:errors', errors, parent)
      this.notifications.triggerMethod(
        'notification:show',
        this.getErrors(errors)
      )
    },

    showSuccessMessages: function (messages) {
      this.notifications.triggerMethod(
        'notification:show',
        this.getSuccessMessages(messages)
      )
    },

    getRedirectUrl: function (msg) {
      var onSuccessRedirect = this.options.onSuccessRedirect

      if (!onSuccessRedirect) return null

      if (_.isString(onSuccessRedirect)) return onSuccessRedirect

      if (msg && _.isString(msg.success)) return msg.success

      return window.location.href
    },

    redirectUser: function (redirectUrl, msg) {
      if (redirectUrl) {
        return redirect(redirectUrl)
      }

      if (msg && msg.success) {
        this.toggleLoading(false)
        this.showSuccessMessages(msg.success, this.$el.attr('name'))
      }
    },

    redirectWhenIsReady: function (url, msg, retries) {
      if (_.isUndefined(retries)) retries = 0
      $.get(url).always((data, statusText, jqXhr) => {
        const isError = statusText === 'error'
        if (isError && retries < 10) {
          setTimeout(() => {
            this.redirectWhenIsReady(url, msg, ++retries)
          }, 1000)
        } else if (isError && retries >= 10) {
          setTimeout(() => {
            this.redirectUser('/')
          }, 1000)
          return this.showErrors([_this.options.labels.connection_error], _this.$el.attr('name')) // eslint-disable-line
        } else {
          this.redirectUser(url, msg)
        }
      })
    },

    checkResponse: function (msg) {
      if (msg && msg.errors) {
        this.toggleLoading(false)
        return this.showErrors(msg.errors, this.$el.attr('name'))
      }

      var redirectUrl = this.getRedirectUrl(msg)

      if (this.ui.submit.hasClass('button-topic-create')) {
        var eventData = {
          'type': 'Topic Creation Success',
          'user_role': window.inSidedData.user.role,
          'topic_title': this.$el.find('#topic_title')[0].value,
          'topic_title_characters': this.$el.find('#topic_title')[0].value.length,
          'topic_type': this.$el.find('#topic_content_type_question')[0].checked ? 'question' : this.$el.find('#topic_content_type_discussion')[0].checked ? 'discussion' : this.$el.find('#topic_content_type_idea')[0].checked ? 'idea' : '',
          'topic_url': `${window.location.origin}${redirectUrl}`,
          'topic_has_description': true,
          'topic_has_category': true,
          'topic_has_tags': this.$el.find('#topic_tags')[0].value !== '',
          'topic_has_attachments': this.$el.find('.add-attachments li').length > 0
        }

        tracker.trackEvent('userevent', eventData, () => {
          this.redirectWhenIsReady(redirectUrl, msg)
        })
      } else {
        this.redirectUser(redirectUrl, msg)
      }
    },

    toggleLoading: function (status) {
      status = !!status
      if (this.ui.submit) {
        this.ui.submit
          .prop('disabled', status)
          .toggleClass('is-loading', status)
      }
    },

    submitForm: function (e) {
      e.preventDefault()

      var self = this
      var $token = this.$el.find('[name$="[_token]"]')
      var formName = this.$el.attr('name')

      this.resetErrors()
      this.toggleLoading(true)

      if ($token.length) {
        // Refresh the CSRF token
        $.get('/site/_tokens?name=' + formName).done(function (data) {
          // Update the token input value
          $token.val(data._token)

          // Update the Yip CSRF Token and continue submit form
          self.updateYipCSRFToken(data.yip_csrf_token).doAjaxCall()
        })
      } else {
        this.doAjaxCall()
      }

      return false
    },

    updateYipCSRFToken: function (token) {
      app.csrf.models[0].set({
        token: token
      })

      return this
    },

    doAjaxCall: function () {
      var self = this
      var method = this.$el.attr('method') || 'post'
      var data = this.$el.serialize().replace('%26amp%3B', '%26')

      $.ajax({
        method: method,
        data: data,
        url: this.$el.attr('action'),
        success: function (msg) {
          setTimeout(function () {
            self.checkResponse(msg)
          }, 300)
        },
        error: function (errors) {
          self.toggleLoading(false)
          self.showErrors(JSON.parse(errors.responseText))
        }
      })
    },

    onRender: function () {
      if (
        this.ui.submit.length > 0 && this.ui.submit.prop('tagName') !== 'input'
      ) {
        this.ui.submit.append('<div class="loader" />')
      }
    }
  })
})
